import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasBadgeComponent } from './gas-badge.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';


const COMPONENTS = [
  GasBadgeComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
  ],
})
export class GasBadgeModule { }
